<template>
  <div class="button-container">
      <button class="button-content">
        <slot></slot>
      </button>
  </div>
</template>

<script>
export default {
  name: 'CustomButton',
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped>
.button-content {
  color: #c8c8c8;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/image/customButton/ButtonNormal.png");
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  font-size: 5.5vw;
  background-color: transparent;
  padding: 1.5vw 2.8vw 2.8vw;
  border: 0;
}
.button-content:active {
  background-image: url("../assets/image/customButton/ButtonClicked.png");
  padding: 1.5vw 2.8vw 2.8vw;
}
</style>
